import type { IAugmentedJQuery, IController, IScope } from "angular";

export default class KendoGridModifierDirectiveController implements IController {
    public static $inject = ["$scope", "$element"];

    private hasSelected: boolean;

    constructor(private $scope: IScope, private $element: IAugmentedJQuery) {}

    public $onInit() {
        this.addAttributeWatch();
    }

    private addAttributeWatch() {
        this.$scope.$watch("$ctrl", () => {
            this.$element.children("table.k-selectable").addClass("table-borderless");
        });
    }
}
